import { cx } from '@orn/shared-web/utils/cx';

import { useDeviceBreakpoints } from '../../../hooks/useDeviceBreakpoints';
import { toCurrency } from '../../../utils/formatting';
import ChangeIndicator from '../../changeIndicators/ChangeIndicator';

export interface IMonthlySpendComparisonChartHeaderProps {
  currentTotal: number;
  previousTotal: number;
  className?: string;
}

export const MonthlySpendComparisonChartHeader = ({
  currentTotal,
  previousTotal,
  className = '',
}: IMonthlySpendComparisonChartHeaderProps) => {
  const { isMobile } = useDeviceBreakpoints();

  const formattedTotal = toCurrency(currentTotal);

  return (
    <div className={cx('bg-secondary border-tertiary flex flex-col gap-5 border-b p-5', className)}>
      {/* Mobile Layout */}
      {isMobile && (
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-1">
            <div className="text-primary text-lg font-semibold">Monthly spend</div>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-primary text-[32px] font-semibold leading-[38px]">{formattedTotal}</div>
            {previousTotal > 0 && (
              <ChangeIndicator
                current={currentTotal}
                previous={previousTotal}
                versusText="vs last month"
                increaseGood={false}
              />
            )}
          </div>
        </div>
      )}

      {/* Desktop Layout */}
      {!isMobile && (
        <div className="flex w-full items-center justify-between gap-4">
          {/* Title */}
          <div className="text-primary text-lg font-semibold">Monthly spend</div>

          {/* Right side: value and comparison */}
          <div className="flex items-center gap-3">
            <div className="text-primary text-xl font-semibold">{formattedTotal}</div>
            {previousTotal > 0 && (
              <ChangeIndicator
                current={currentTotal}
                previous={previousTotal}
                versusText="vs last month"
                increaseGood={false}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
